import { Injectable } from '@angular/core';
import {
  DatePicker,
  Dropdown,
  FromAndTo
} from '@com-delta-omnichannel/mach-core-js';
import { VacationWidget } from '../models/vacation-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class VacationWidgetInitializationService {
  initializeComponents(content: VacationWidget): {
    airportPicker: FromAndTo;
    rangeDatePickerInstance: DatePicker;
    dropdownPassengerOptions: Dropdown;
    dropdownRoomOptions: Dropdown;
  } {
    return {
      airportPicker: new FromAndTo(content.fromAndToOption),
      rangeDatePickerInstance: new DatePicker(content.dropDownDateOption),
      dropdownPassengerOptions: new Dropdown(content.dropDownPassengerOption),
      dropdownRoomOptions: new Dropdown(content.dropDownRoomOption)
    };
  }

  getRequiredElements(content: VacationWidget): boolean {
    const elementIds = [
      content.fromAndToOption.id,
      content.dropDownPassengerOption.id,
      content.dropDownRoomOption.id,
      content.dropDownDateOption.triggerElementId ?? 'max-range-date-trigger'
    ];
    return elementIds.every((id) => document.getElementById(id));
  }

  registerFromAndToInstance(
    airportPicker: FromAndTo,
    onOriginClick: () => void,
    onDestinationClick: () => void,
    onSwap: () => void
  ): void {
    airportPicker.onOriginClick(onOriginClick);
    airportPicker.onDestinationClick(onDestinationClick);
    airportPicker.onSwap(onSwap);
  }

  openDatePicker(rangeDatePickerInstance: DatePicker): void {
    if (rangeDatePickerInstance.isOpen()) {
      rangeDatePickerInstance.close();
    } else {
      rangeDatePickerInstance.open();
    }
  }
}
